
import { IntlShape, createIntl, createIntlCache } from "react-intl";
import messageJson from './translations.json';
import { showTranslationKeys } from "../global";


export const locale = "en";

export interface LanguageFile {
    [key: string]: {
        [key: string]: string
    }
}

let fabrixMessages = messageJson as LanguageFile;

let intl: IntlShape;


export const translate = (id: string, values?: {}) => {
    
    try {
        if (showTranslationKeys)
            return id;

        if (intl) {
            return intl.formatMessage({ id: id, defaultMessage: id }, values);
        }
        return id;
    } catch {
        
        return id;
    }
}

const initializeTranslations = (languageFile: LanguageFile) => {
    const cache = createIntlCache();
    let int = createIntl(
        {
            locale: locale,
            messages: languageFile[locale]
        },
        cache
    );
    return int;
}

export const loadTranslations = (translations: LanguageFile) => {
    let currentMessages: any = {};
    if (intl) {
        currentMessages = intl.messages;
    } else {
        currentMessages = fabrixMessages[locale]
    }
    let messages: LanguageFile = { [locale]: { ...translations[locale] } }
    intl = initializeTranslations(messages);
}